import { render, staticRenderFns } from "./editTelephone.vue?vue&type=template&id=01467ec8&scoped=true&"
import script from "./editTelephone.vue?vue&type=script&lang=js&"
export * from "./editTelephone.vue?vue&type=script&lang=js&"
import style0 from "./editTelephone.vue?vue&type=style&index=0&id=01467ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01467ec8",
  null
  
)

export default component.exports